
<div class="d-flex justify-content-between align-items-center gap-3 mb-2">
    <h3 class="fs-18 fw600 text-bodyGrey mb-0">Site details</h3>
    <button class="GA-edit btn-secondary btn-xs" id="editSiteDetailButton" (click)="openEditSiteModal()">Edit</button>
  </div>
<div class="card bg-lilac h-100 mb-4">
    <div class="card-body">
        <div class="row">
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="form-label fs-14 fw400 text-brightPurple text-nowrap mb-2">Floor area</label>
                <p class="mb-0 fs-16 fw400">{{siteData?.floorArea | number: '1.0-0'}} m<sup>2</sup></p>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="form-label fs-14 fw400 text-brightPurple text-nowrap mb-2">Number of floors</label>
                <p class="mb-0 fs-16 fw400">{{(siteData?.floorCount | number: '1.0-2') || '1'}}</p>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="form-label fs-14 fw400 text-brightPurple text-nowrap mb-2">Property type</label>
                <p class="mb-0 fs-16 fw400">{{siteData?.propertyType}}</p>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="form-label fs-14 fw400 text-brightPurple text-nowrap mb-2">Listed Grade</label>
                <p class="mb-0 fs-16 fw400">{{siteData?.listedGrade || 'N/A'}}</p>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="form-label fs-14 fw400 text-brightPurple text-nowrap mb-2">Premise Type</label>
                <p class="mb-0 fs-16 fw400">{{siteData?.premiseType || 'N/A' }}</p>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="form-label fs-14 fw400 text-brightPurple text-nowrap mb-2">Address</label>
                <p class="mb-0 fs-16 fw400">{{siteData?.siteAddress}}</p>
            </div>
        </div>
    </div>
</div>